/** Simple stroke figures for the account-type / seeking choices. */
type P = React.SVGProps<SVGSVGElement>;

function Base({ children, ...props }: P) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className="size-7"
      {...props}
    >
      {children}
    </svg>
  );
}

export function ManIcon(props: P) {
  return (
    <Base {...props}>
      <circle cx="12" cy="7" r="3.2" />
      <path d="M6 20a6 6 0 0 1 12 0" />
    </Base>
  );
}

export function WomanIcon(props: P) {
  return (
    <Base {...props}>
      <circle cx="12" cy="7" r="3.2" />
      <path d="M8.5 20 12 12l3.5 8M9.5 16h5" />
    </Base>
  );
}

export function CoupleIcon(props: P) {
  return (
    <Base {...props}>
      <circle cx="8" cy="7" r="2.6" />
      <circle cx="16" cy="7" r="2.6" />
      <path d="M3.5 20a4.5 4.5 0 0 1 9 0M11.5 20a4.5 4.5 0 0 1 9 0" />
    </Base>
  );
}
